import { ptToCssPx } from "@burfy/docs-core";
//#region src/print/printDocument.ts
function printGeometryVariables(geometry) {
	const px = (pt) => `${ptToCssPx(pt)}px`;
	return {
		"--burfy-docs-page-width": `${geometry.widthPt}pt`,
		"--burfy-docs-page-height": `${geometry.heightPt}pt`,
		"--burfy-docs-margin-top": px(geometry.contentOriginPt.yPt),
		"--burfy-docs-margin-right": px(geometry.margins.rightPt),
		"--burfy-docs-margin-bottom": px(geometry.margins.bottomPt),
		"--burfy-docs-margin-left": px(geometry.margins.leftPt)
	};
}
/** Apply the geometry variables to an element (the document root, normally). */
function applyPrintGeometry(element, geometry) {
	for (const [name, value] of Object.entries(printGeometryVariables(geometry))) element.style.setProperty(name, value);
}
/**
* Publish the page background for printing, or clear it.
*
* Takes the resolved CSS rather than the model, because an image background is
* an `asset:` reference that only the caller can turn into a URL.
*
* Cleared rather than left behind when there is nothing to print: a background
* removed from the document would otherwise keep printing.
*/
function applyPrintBackground(element, background) {
	const css = background?.css;
	if (!css) {
		element.removeAttribute("data-burfy-print-background");
		element.style.removeProperty("--burfy-docs-print-background");
		element.style.removeProperty("--burfy-docs-print-background-opacity");
		return;
	}
	element.style.setProperty("--burfy-docs-print-background", css);
	element.style.setProperty("--burfy-docs-print-background-opacity", String(background?.opacity ?? 1));
	element.setAttribute("data-burfy-print-background", "");
}
/**
* Print the current document.
*
* The geometry is published before the dialog opens and left in place
* afterwards — it is inert outside `@media print`, and removing it during the
* dialog would change the page size mid-print in browsers that render the
* preview lazily.
*/
function printDocument(geometry, options = {}) {
	if (typeof window === "undefined") return;
	const element = options.target ?? window.document.documentElement;
	applyPrintGeometry(element, geometry);
	applyPrintBackground(element, options.background);
	window.print();
}
//#endregion
export { printDocument as n, printGeometryVariables as r, applyPrintGeometry as t };
